import { Store } from '@src/application/store/store';
import { StateDefinition } from '@src/application/store/state-definition.js';
import { LegacyObjectStore } from '@src/application/store/legacy-store-interface.js';

const store = new Store({
    openLoaders: new StateDefinition(0, false),
    message: new StateDefinition(null, false),
    deploying: new StateDefinition(0, false),
});

export default store as unknown as LegacyObjectStore<{
    openLoaders: number,
    message: string|null,
    deploying: number,
}>;
